'use client';

import type { ComponentPropsWithoutRef } from 'react';
import type { IconType } from 'react-icons';

import type { SvgIcon } from '../utils/types/svg-icon';
import styles from './tag.component.module.scss';

type Props = {
  /**
   * タグの色を指定します
   */
  color?: 'grey' | 'blue' | 'orange' | 'yellow' | 'green';
  /**
   * タグに表示するテキストです
   */
  text?: string;
  /**
   * タグに表示するアイコンです
   */
  icon?: IconType | SvgIcon;
  /**
   * - アイコンに親のスタイルを継承させず、アイコン自体のビジュアルを適用します
   * - 外部サービスのロゴのレギュレーションを守る必要がある時などに使用します
   */
  disableIconStyle?: boolean;
  /**
   * グレータグのフォントを太字にします
   */
  bold?: boolean;
} & ComponentPropsWithoutRef<'span'>;
export const Tag = ({
  children,
  color,
  bold,
  text,
  icon: Icon,
  disableIconStyle,
  className,
  ...rest
}: Props) => {
  return (
    <span
      className={[className, styles.tag].filter(Boolean).join(' ')}
      data-bold={bold}
      data-color={color || 'grey'}
      data-disable-icon-style={disableIconStyle || undefined}
      {...rest}
    >
      {Icon && <Icon aria-hidden />}
      {text && <span>{text}</span>}
      {children}
    </span>
  );
};
